import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "ml-4" }
const _hoisted_3 = { class: "bg-white" }
const _hoisted_4 = {
  scope: "col",
  class: "px-6 py-3 relative",
  style: {"z-index":"0"}
}
const _hoisted_5 = {
  scope: "col",
  class: "px-6 py-3 relative",
  style: {"z-index":"0"}
}
const _hoisted_6 = {
  scope: "col",
  class: "px-6 py-3 relative",
  style: {"z-index":"0"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
}, " Ülesvõtete arv ", -1)
const _hoisted_8 = { class: "px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-700" }
const _hoisted_9 = { class: "px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-700" }
const _hoisted_10 = { class: "px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-700" }
const _hoisted_11 = { class: "mt-2 w-full flex justify-end pr-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MDatePicker = _resolveComponent("MDatePicker")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_BaseTableBodyWrapper = _resolveComponent("BaseTableBodyWrapper")!
  const _component_BaseTableWrapper = _resolveComponent("BaseTableWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.worker.name) + " - " + _toDisplayString(_ctx.clinic.name), 1),
    _createVNode(_component_MDatePicker, {
      class: "w-96 mt-6 ml-5",
      onOnDate: _ctx.onDate,
      "initial-date": new Date(_ctx.timestamp),
      placeholder: "Lisamise kuupäev",
      label: ""
    }, null, 8, ["onOnDate", "initial-date"]),
    _createVNode(_component_BaseTableWrapper, null, {
      default: _withCtx(() => [
        _createElementVNode("thead", _hoisted_3, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_4, [
              _createVNode(_component_InputField, {
                label: "Kabinet",
                value: _ctx.cabinetName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cabinetName) = $event)),
                "is-autocomplete": false
              }, null, 8, ["value"])
            ]),
            _createElementVNode("th", _hoisted_5, [
              _createVNode(_component_InputField, {
                label: "Seade",
                value: _ctx.equipmentName,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.equipmentName) = $event)),
                "is-autocomplete": false
              }, null, 8, ["value"])
            ]),
            _createElementVNode("th", _hoisted_6, [
              _createVNode(_component_InputField, {
                label: "Ülesvõtte liik",
                value: _ctx.imageName,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.imageName) = $event)),
                "is-autocomplete": false
              }, null, 8, ["value"])
            ]),
            _hoisted_7
          ])
        ]),
        _createVNode(_component_BaseTableBodyWrapper, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: image.imageUID
              }, [
                _createElementVNode("td", _hoisted_8, _toDisplayString(image.cabinetName), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(image.equipmentName), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(image.imageName), 1),
                _createElementVNode("td", null, [
                  _createVNode(_component_InputField, {
                    label: "Ülesvõtete arv",
                    "input-type": _ctx.InputFieldType.NUMBER,
                    "is-autocomplete": false,
                    value: _ctx.getImageCount(image.imageUID),
                    onOnValue: count => _ctx.onCount({uid: image.imageUID, count})
                  }, null, 8, ["input-type", "value", "onOnValue"])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args))),
        class: "transition duration-300 ease-in-out inline-flex items-center px-4 py-2 border border-transparent text-sm font-normal rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      }, " Salvesta ")
    ])
  ]))
}